if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    class ProductOptions extends window.BAO.CustomElement {
      constructor() {
        super()

        this.triggerEls = this.querySelectorAll(
          '[data-el="product-options.trigger"]',
        )
        this.titleEls = this.querySelectorAll('[data-el="product-options.title"]')
        this.selectEls = this.querySelectorAll('[data-el="product-options.select"]')
        this.variants = this.getVariantData()

        if (this.triggerEls.length < 1) return

        this.initialiseOptionButtons()
        this.refreshSoldOut()
      }

      connectedCallback() {
        super.connectedCallback()
        this.restoreSavedSize()
      }

      initialiseOptionButtons() {
        this.triggerEls.forEach(triggerEl => {
          triggerEl.addEventListener('click', this.handleTrigger)
        })
      }

      handleTrigger = event => {
        const triggerEl = event.currentTarget
        const optionIndex = triggerEl.dataset.index
        const optionValue = triggerEl.dataset.value
        const optionTitle = triggerEl.dataset.title

        this.triggerEls.forEach(el => {
          if (el.dataset.index === optionIndex) {
            el.setAttribute('aria-pressed', el === triggerEl)
          }
        })

        this.selectEls.forEach(selectEl => {
          if (selectEl.dataset.index === optionIndex) {
            selectEl.value = optionValue

            selectEl.dispatchEvent(new Event('change', {
              bubbles: true
            }))
          }
        })

        this.titleEls.forEach(titleEl => {
          if (titleEl.dataset.index === optionIndex) {
            titleEl.innerHTML = optionTitle
          }
        })

        this.refreshSoldOut()
      }

      restoreSavedSize() {
        const savedSize = sessionStorage.getItem('savedSize')
        if (!savedSize) return

        // The colour swap inserts this picker before variant-selects is listening.
        // Wait until that listener exists, then apply the size if this colour has it.
        window.setTimeout(() => {
          if (!this.isConnected || sessionStorage.getItem('savedSize') !== savedSize) return

          sessionStorage.removeItem('savedSize')

          const match = [...this.querySelectorAll('[data-el="product-options.trigger"]')].find(el => {
            return this.valuesMatch(el.dataset.value, savedSize)
              || this.valuesMatch(el.dataset.title, savedSize)
          })

          if (!match || match.getAttribute('aria-pressed') === 'true') return

          match.click()
        }, 0)
      }

      refreshSoldOut() {
        if (!this.variants.length) return

        const selected = {}
        this.triggerEls.forEach(el => {
          if (el.getAttribute('aria-pressed') === 'true') {
            selected[el.dataset.index] = el.dataset.value
          }
        })

        this.triggerEls.forEach(el => {
          const available = this.variants.some(variant => {
            if (!this.valuesMatch(variant[el.dataset.index], el.dataset.value)) {
              return false
            }

            const othersMatch = Object.entries(selected).every(
              ([selectedIndex, selectedValue]) => {
                if (selectedIndex === el.dataset.index) return true
                return this.valuesMatch(variant[selectedIndex], selectedValue)
              },
            )

            return othersMatch && variant.available
          })

          el.classList.toggle('prd-Options_Button-soldOut', !available)
        })
      }

      getVariantData() {
        const json = this.querySelector('[type="application/json"]')
        if (!json) return []

        try {
          return JSON.parse(json.textContent) || []
        } catch (error) {
          return []
        }
      }

      valuesMatch(a, b) {
        return this.normalize(a) === this.normalize(b)
      }

      normalize(value) {
        if (value == null || value === '') return ''
        return String(value).split('|')[0].toLowerCase().trim()
      }
    },
  )
}
